import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { EASE } from "@/components/Reveal";

const marqueeItems = [
  "INDUSTRIAL DESIGN",
  "VEHICLE",
  "MOTORCYCLE",
  "CAD",
  "VR",
  "FABRICATION",
];

const Hero = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], ["0%", "28%"]);
  const scale = useTransform(scrollYProgress, [0, 1], [1, 1.15]);
  const overlayOpacity = useTransform(scrollYProgress, [0, 1], [0.5, 0.85]);

  const marqueeLoop = [...marqueeItems, ...marqueeItems];

  return (
    <section
      ref={ref}
      data-testid="hero"
      className="relative h-[100svh] w-full overflow-hidden bg-black"
    >
      {/* Parallax media — studio hero video */}
      <motion.div style={{ y, scale }} className="absolute inset-0">
        <video
          src="/hero-video.mp4"
          autoPlay
          loop
          muted
          playsInline
          className="h-full w-full object-cover"
        />
      </motion.div>
      <motion.div
        style={{ opacity: overlayOpacity }}
        className="absolute inset-0 bg-black"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-transparent to-black/40" />

      {/* Center logo reveal */}
      <div className="absolute inset-0 z-10 flex items-center justify-center px-6 -translate-y-[15%]">
        <motion.img
          src="/cerra-logo-white.png"
          alt="Cerra Design"
          initial={{ opacity: 0, scale: 1.08, filter: "blur(8px)" }}
          animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
          transition={{ duration: 1.4, ease: EASE, delay: 0.2 }}
          className="hero-logo w-[78vw] max-w-[620px] h-auto"
        />
      </div>

      {/* Slogan — lower portion */}
      <div className="hero-slogan-wrap absolute bottom-[104px] left-0 right-0 z-10 px-6 text-center">
        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, ease: EASE, delay: 1.0 }}
          className="hero-slogan font-head font-medium text-white text-2xl sm:text-3xl lg:text-4xl kern-tight"
        >
          Advanced Design. <span className="italic">Engineering</span> Craft.
        </motion.h1>
      </div>

      {/* Scrolling category marquee */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.4, duration: 0.8 }}
        className="absolute bottom-0 left-0 right-0 z-10 overflow-hidden border-t border-white/15 py-4 sm:py-5"
      >
        <div className="marquee-track">
          {marqueeLoop.map((item, i) => (
            <span key={i} className="flex items-center">
              <span className="font-head font-medium text-white/80 text-sm sm:text-base uppercase tracking-[0.2em] px-6">
                {item}
              </span>
              <span className="text-white/25 px-2">/</span>
            </span>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
